import { readPmTaskPreview, type PmTaskPreview } from './pm-task-preview.js';

export type PmMessageSnapshot = { card: PmTaskPreview; fetchedAt: string; snapshotRevision: string };
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function pmMessageSnapshotPath(messageId: string, taskId: string, messageVersion: number): string {
  return `/v1/messages/${messageId}/pm-task-previews/${taskId}?message_version=${messageVersion}`;
}
export function readPmMessageSnapshot(value: unknown, messageId: string, taskId: string, messageVersion: number): PmMessageSnapshot | null {
  if (!uuid.test(messageId) || !Number.isSafeInteger(messageVersion) || messageVersion <= 0 || messageVersion > 2147483647
    || !value || typeof value !== 'object' || Array.isArray(value)) return null;
  const input = value as Record<string, unknown>;
  if (typeof input.snapshotRevision !== 'string' || !/^[1-9]\d{0,18}$/.test(input.snapshotRevision)
    || BigInt(input.snapshotRevision) > 9223372036854775807n || typeof input.fetchedAt !== 'string'
    || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(input.fetchedAt)
    || !Number.isFinite(Date.parse(input.fetchedAt)) || new Date(input.fetchedAt).toISOString() !== input.fetchedAt) return null;
  const card = readPmTaskPreview(input.card, taskId);
  if (!card) return null;
  const asset = (kind: string) => `/v1/messages/${messageId}/pm-task-previews/${taskId}/assets/${kind}?message_version=${messageVersion}&snapshot_revision=${input.snapshotRevision}`;
  if (card.project.iconUrl) card.project.iconUrl = asset('project-icon');
  if (card.assignee?.avatarUrl) card.assignee.avatarUrl = asset('assignee-avatar');
  return { card, fetchedAt: input.fetchedAt, snapshotRevision: input.snapshotRevision };
}
